import {objectAtPathReducer} from "../../index";
import OIDCOptions from "./OIDCOptions";
import {LOAD_USER_ERROR, LOADING_USER, REDIRECT_SUCCESS, SESSION_TERMINATED, SILENT_RENEW_ERROR, USER_EXPIRED, USER_EXPIRING, USER_FOUND, USER_SIGNED_OUT} from "redux-oidc";
import pathToParts from "../../common/PathToParts";

// create reducers for the redux-oidc actions; redux-oidc does have a middleware for this... if you're brave...

const removeUser = state => objectAtPathReducer(state, {payload: createPathActionPayload(OIDCOptions.reduxUserPath, undefined)});
const setUser = (state, action) => objectAtPathReducer(state, {payload: createPathActionPayload(OIDCOptions.reduxUserPath, action.payload)});
const noop = state => ({...state});

export default reducers => {
	reducers[USER_FOUND] = setUser;

	reducers[SESSION_TERMINATED] = removeUser;
	reducers[USER_EXPIRED] = removeUser;
	reducers[SILENT_RENEW_ERROR] = removeUser;
	reducers[USER_SIGNED_OUT] = removeUser;
	reducers[LOAD_USER_ERROR] = removeUser;

	reducers[REDIRECT_SUCCESS] = noop;
	reducers[USER_EXPIRING] = noop;
	reducers[LOADING_USER] = noop;

	// apps copied from Examples will have this, otherwise add it so OIDCCore can set OIDCOptions.reduxUserPath default object
	if (!reducers['UPDATE_DATA']) {
		reducers['UPDATE_DATA'] = objectAtPathReducer;
	}
};

const createPathActionPayload = (path, value) => Object.assign({ value }, pathToParts(path));
